import React from 'react';
export const LoadingSkeleton = () => {
  return (
    <div className="w-full h-full flex items-center justify-center">
      <div className="animate-pulse bg-gray-700/50 rounded w-3/4 h-3/4" />
    </div>
  );
};
